// extracted by mini-css-extract-plugin
export default {"tooltip":"pX-z","arrow":"qX-z"};